// src/pages/Profile/Profile2.tsx

import { FC } from 'react';
import styles from '../../css/ProfilePage.module.css';
import { motion, Variants } from 'framer-motion';
import { ArrowLeft, Mail, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';

// Import Image
import ProfileImg2 from '../../assets/images/ProfileImage2.jpeg';

const Profile2: FC = () => {
    
    const fadeInUp: Variants = {
        hidden: { opacity: 0, y: 20 },
        visible: { 
            opacity: 1, 
            y: 0, 
            transition: { duration: 0.6, ease: "easeOut" } 
        }
    };

    const staggerContainer: Variants = {
        visible: {
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    return (
        <div className={styles.profilePage}>
            
            <section className={styles.heroSection}>
                <div className={styles.gridBackground}></div>
                <div className={styles.container}>
                    
                    {/* Back Navigation */}
                    <div className={styles.backLinkWrapper}>
                        <Link to="/about" className={styles.backLink}>
                            <ArrowLeft size={16} /> Back to Leadership
                        </Link>
                    </div>

                    <div className={styles.profileHeader}>
                        
                        {/* Left: Image & Socials */}
                        <motion.div 
                            className={styles.imageColumn}
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className={styles.profileImageWrapper}>
                                <img src={ProfileImg2} alt="Prof. Godfred Amewu" className={styles.profileImage} />
                            </div>
                            <div className={styles.socialRow}>
                                <a 
                                    href="https://ugbs.ug.edu.gh/faculty/godfred-amewu" 
                                    target="_blank" 
                                    rel="noreferrer" 
                                    className={styles.socialBtn}
                                    aria-label="Academic Profile"
                                >
                                    <Globe size={20} />
                                </a>
                                <a 
                                    href="mailto:contact@otatech.com" 
                                    className={styles.socialBtn}
                                    aria-label="Contact"
                                >
                                    <Mail size={20} />
                                </a>
                            </div>
                        </motion.div>

                        {/* Right: Biography */}
                        <motion.div 
                            className={styles.infoColumn}
                            initial="hidden"
                            animate="visible"
                            variants={staggerContainer}
                        >
                            <motion.h1 className={styles.name} variants={fadeInUp}>
                                Prof. Godfred Amewu
                            </motion.h1>
                            <motion.div className={styles.title} variants={fadeInUp}>
                                Global Strategy Advisor | Board Member, OTA TECH Inc.
                            </motion.div>

                            <motion.div className={styles.bioSection} variants={fadeInUp}>
                                <h2>Professional Overview</h2>
                                <p className={styles.bioText}>
                                    Prof. Godfred Amewu serves as a <strong>Board Member and Global Strategy Advisor</strong> for OTA TECH Inc., bringing decades of academic and practical financial expertise to our governance structure.
                                </p>
                                <p className={styles.bioText}>
                                    He is an Associate Professor in Finance at the <strong>University of Ghana Business School (UGBS)</strong>. Prior to joining UGBS, he was a Senior Lecturer and Researcher in Finance at the GIMPA Business School, where he trained students, public servants, diplomats, and NGO workers from across Africa.
                                </p>
                            </motion.div>

                            <motion.div className={styles.bioSection} variants={fadeInUp}>
                                <h2>Impact Investing Leadership</h2>
                                <p className={styles.bioText}>
                                    Prof. Amewu is a pioneering figure in the development of <strong>impact investing as an asset class in Africa</strong>. 
                                </p>
                                <p className={styles.bioText}>
                                    He formerly served as the Co-ordinator for the <strong>GIMPA Centre for Impact Investing (GCII)</strong>, overseeing research, performance measurement, and investment strategy. He currently works closely with top institutions in Ghana, the Global Impact Investing Network (GIIN), and international donor organizations to drive sustainable financial frameworks.
                                </p>
                            </motion.div>

                            <motion.div className={styles.bioSection} variants={fadeInUp}>
                                <h2>Strategic Advisory</h2>
                                <p className={styles.bioText}>
                                    He is an associate at several prominent development think tanks and academic institutions. Prof. Amewu provides high-level policy advice and consulting services to government departments, bilateral donors, international organizations, and large corporations, ensuring that financial strategies align with broader economic development goals.
                                </p>
                            </motion.div>

                            <motion.div className={styles.bioSection} variants={fadeInUp}>
                                <h2>Academic Credentials</h2>
                                <p className={styles.bioText}>
                                    <strong>PhD:</strong> University of the Witwatersrand, South Africa.
                                </p>
                                <p className={styles.bioText}>
                                    <strong>MSc in Finance:</strong> University of St. Andrews (UK).
                                </p>
                                <p className={styles.bioText}>
                                    <strong>BSc (Honours) Mathematics:</strong> Kwame Nkrumah University of Science and Technology (Ghana).
                                </p>
                            </motion.div>

                        </motion.div>
                    </div>
                </div>
                <div className={styles.heroFade}></div>
            </section>
        </div>
    );
};

export default Profile2;